/* ============================================================
   RYVOX — global.js
   Lightweight vanilla enhancements. No framework.
   Core commerce works without JS; this improves the experience.
   ============================================================ */
(function () {
  'use strict';

  var routes = window.RyvoxRoutes || {};
  var strings = window.RyvoxStrings || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  /* Cart JSON is merchant data, but 26 live product titles contain a literal
     double quote (17" supermoto wheel sets). Interpolating those raw into an
     attribute shreds the markup, so every JSON-sourced value goes through here —
     same helper the builders and collection.js already use. */
  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function money(cents) {
    try { return (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents, window.RyvoxMoneyFormat)
      : '$' + (cents / 100).toFixed(2); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* ---------- Shared colour swatch resolver ----------
     Mirrors snippets/option-swatch.liquid exactly (same whitelist, same hexes)
     so a pill rendered by Liquid on the PDP and a pill rendered by JS inside a
     builder tile paint identically. Multi-part values ("BLACK HUB/GOLD RIM/…")
     become a hard-stop gradient of up to four colours, in the order they appear. */
  var SWATCH_WORDS = {
    black: '#15171d', white: '#f4f6fa', silver: '#c3c8d1', chrome: '#dfe4ec',
    gray: '#8b909b', grey: '#8b909b', red: '#e5484d', blue: '#2f6bff',
    teal: '#1ed9c6', green: '#2fbf71', yellow: '#f2c94c', orange: '#f2994a',
    gold: '#d4af37', bronze: '#9c6b30', mag: '#9a8f76', magnesium: '#9a8f76',
    purple: '#a855f7', violet: '#6d3fd1'
  };
  function swatchCss(value) {
    if (value == null) return '';
    var tokens = String(value).toLowerCase().replace(/[\/,\-()]/g, ' ').split(/\s+/);
    var hexes = [], seen = {};
    for (var i = 0; i < tokens.length && hexes.length < 4; i++) {
      var t = tokens[i];
      if (!t || seen[t] || !Object.prototype.hasOwnProperty.call(SWATCH_WORDS, t)) continue;
      seen[t] = true;
      hexes.push(SWATCH_WORDS[t]);
    }
    if (!hexes.length) return '';
    if (hexes.length === 1) return hexes[0];
    var step = Math.floor(100 / hexes.length);
    return 'linear-gradient(135deg,' + hexes.map(function (h, n) {
      var to = n === hexes.length - 1 ? 100 : (n + 1) * step;
      return h + ' ' + (n * step) + '% ' + to + '%';
    }).join(',') + ')';
  }
  window.RyvoxSwatch = { css: swatchCss, words: SWATCH_WORDS };

  /* ---------- "Show all N" toggle for long option groups ----------
     Delegated so it also works for pill groups rendered later by the
     bike builder / wheel builder. */
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return;
    var toggle = target.closest('[data-vgroup-toggle]');
    if (!toggle) return;
    e.preventDefault();
    var group = toggle.closest('[data-vgroup]');
    if (!group) return;
    var expanded = group.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    var less = toggle.getAttribute('data-label-less') || 'Show less';
    var more = toggle.getAttribute('data-label-more') || toggle.textContent;
    if (!toggle.getAttribute('data-label-more')) toggle.setAttribute('data-label-more', more);
    toggle.textContent = expanded ? less : toggle.getAttribute('data-label-more');
  });

  /* ---------- Header scroll state ---------- */
  var headerWrap = $('[data-header-wrap]');
  if (headerWrap) {
    var onScroll = function () {
      headerWrap.setAttribute('data-scrolled', window.scrollY > 24 ? 'true' : 'false');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Generic drawer controller ---------- */
  function Drawer(el) {
    this.el = el;
    this.lastFocus = null;
    var self = this;
    $all('[data-drawer-close]', el).forEach(function (b) {
      b.addEventListener('click', function () { self.close(); });
    });
    var overlay = $('[data-drawer-overlay]', el);
    if (overlay) overlay.addEventListener('click', function () { self.close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.classList.contains('is-open')) self.close();
    });
    // Focus trap: keep Tab cycling inside the drawer while it is open.
    el.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !el.classList.contains('is-open')) return;
      var focusables = self.focusables();
      if (!focusables.length) { e.preventDefault(); return; }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      var active = document.activeElement;
      if (e.shiftKey) {
        if (active === first || !el.contains(active)) { e.preventDefault(); last.focus(); }
      } else if (active === last || !el.contains(active)) {
        e.preventDefault(); first.focus();
      }
    });
  }
  Drawer.prototype.focusables = function () {
    return $all(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      this.el
    ).filter(function (n) {
      return n.getClientRects().length > 0 && !n.closest('[hidden]');
    });
  };
  Drawer.prototype.open = function () {
    this.lastFocus = document.activeElement;
    this.el.classList.add('is-open');
    this.el.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    var focusable = this.focusables()[0];
    if (focusable) focusable.focus();
  };
  Drawer.prototype.close = function () {
    this.el.classList.remove('is-open');
    document.body.style.overflow = '';
    if (this.lastFocus) this.lastFocus.focus();
  };

  /* ---------- Wire drawers ---------- */
  var drawers = {};
  $all('[data-drawer]').forEach(function (el) {
    drawers[el.getAttribute('data-drawer')] = new Drawer(el);
  });
  $all('[data-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var key = btn.getAttribute('data-drawer-open');
      if (drawers[key]) drawers[key].open();
    });
  });

  /* ---------- Cart: fetch + render drawer ---------- */
  var cartDrawerEl = $('[data-drawer="cart"]');

  function updateCartCount(count) {
    $all('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  function renderCartDrawer(cart) {
    if (!cartDrawerEl) return;
    var body = $('[data-cart-items]', cartDrawerEl);
    var subtotal = $('[data-cart-subtotal]', cartDrawerEl);
    var foot = $('[data-cart-foot]', cartDrawerEl);
    var empty = $('[data-cart-empty]', cartDrawerEl);
    updateCartCount(cart.item_count);
    if (!body) return;

    // Free-shipping progress bar (threshold in cents).
    var goal = 29900;
    var goalEl = $('[data-cart-goal]', cartDrawerEl);
    if (goalEl) {
      if (cart.item_count === 0) {
        goalEl.hidden = true;
      } else {
        goalEl.hidden = false;
        var goalFill = $('[data-cart-goal-fill]', goalEl);
        var goalText = $('[data-cart-goal-text]', goalEl);
        var pct = Math.min(100, Math.round(cart.total_price / goal * 100));
        if (goalFill) goalFill.style.width = pct + '%';
        if (goalText) {
          if (cart.total_price >= goal) goalText.textContent = 'Free shipping unlocked on standard parcels';
          else goalText.textContent = 'Add ' + money(goal - cart.total_price) + ' for free shipping';
        }
      }
    }

    if (cart.item_count === 0) {
      body.innerHTML = '';
      if (empty) empty.hidden = false;
      if (foot) foot.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (foot) foot.hidden = false;

    body.innerHTML = cart.items.map(function (item) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1') : '';
      var variant = (item.options_with_values || [])
        .filter(function (o) { return o.value !== 'Default Title'; })
        .map(function (o) { return escapeHtml(o.value); }).join(' / ');
      /* Line-item properties (e.g. Backorder: Ships after October 7, 2026).
         Keys starting with "_" are app-internal and stay hidden, as Shopify does. */
      var props = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (k) {
          var val = item.properties[k];
          if (!k || k.charAt(0) === '_' || val == null || val === '') return;
          props += '<div class="line-item__meta line-item__prop">' + escapeHtml(k) + ': ' + escapeHtml(val) + '</div>';
        });
      }
      return '' +
        '<div class="line-item" data-line-key="' + escapeHtml(item.key) + '">' +
          '<div class="line-item__img">' + (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(item.product_title) + '" width="64" height="64" loading="lazy">' : '') + '</div>' +
          '<div>' +
            '<div class="line-item__title"><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a></div>' +
            (variant ? '<div class="line-item__meta">' + variant + '</div>' : '') +
            props +
            (item.properties && /^Build: .+ (front|rear) wheel #[A-Z0-9]+$/i.test(item.properties.Build || '') ? '<p class="line-item__meta">' + escapeHtml(strings.build_controls || '') + '</p>' : '') +
            '<div class="qty" style="margin-top:.5rem">' +
              '<button type="button" aria-label="Decrease" data-qty-change="' + escapeHtml(item.key) + '" data-qty="' + (item.quantity - 1) + '">&minus;</button>' +
              '<input type="text" value="' + item.quantity + '" readonly aria-label="Quantity">' +
              '<button type="button" aria-label="Increase" data-qty-change="' + escapeHtml(item.key) + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
            '</div>' +
            '<button type="button" class="line-item__remove" data-qty-change="' + escapeHtml(item.key) + '" data-qty="0">' + escapeHtml(strings.remove || 'Remove') + '</button>' +
          '</div>' +
          '<div class="line-item__price">' + money(item.final_line_price) + '</div>' +
        '</div>';
    }).join('');

    if (subtotal) subtotal.textContent = money(cart.total_price);

    // Shop Pay Installments note: only when the cart total clears $150.
    var installments = $('[data-installments-note]', cartDrawerEl);
    if (installments) installments.hidden = !(cart.total_price > 15000);

    // Keep the note field in sync with the server-side cart (unless the user is mid-edit).
    var noteField = $('[data-cart-note]', cartDrawerEl);
    if (noteField && document.activeElement !== noteField && typeof cart.note === 'string') {
      noteField.value = cart.note;
    }
  }

  function refreshCart(openDrawer) {
    return fetch(routes.cart_url ? routes.cart_url + '.js' : '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        if (openDrawer && drawers.cart) drawers.cart.open();
        return cart;
      });
  }

  /* Change one cart line. `ref` is either a line item key (preferred — stable
     across re-renders) or a 1-based line index; /cart/change.js accepts both,
     under `id` and `line` respectively. */
  function changeLine(ref, qty, useLine) {
    return fetch(routes.cart_url ? routes.cart_url + '.js' : '/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to read cart');
        return response.json();
      }).then(function (current) {
        var item = useLine ? current.items[parseInt(ref, 10) - 1] : current.items.find(function (line) { return line.key === ref; });
        if (!item) throw new Error('Cart item has changed');
        var build = item.properties && item.properties.Build;
        var grouped = typeof build === 'string' && /^Build: .+ (front|rear) wheel #[A-Z0-9]+$/i.test(build);
        var payload = { id: item.key, quantity: qty };
        var endpoint = routes.cart_change_url ? routes.cart_change_url + '.js' : '/cart/change.js';
        if (grouped) {
          payload = { updates: {} };
          current.items.forEach(function (line) {
            if (line.properties && line.properties.Build === build) payload.updates[line.key] = qty;
          });
          endpoint = routes.cart_update_url ? routes.cart_update_url + '.js' : '/cart/update.js';
        }
        return fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
      }).then(function (response) {
        if (!response.ok) throw new Error('Unable to update cart');
        return response.json();
      }).then(function (cart) {
      updateCartCount(cart.item_count);
      renderCartDrawer(cart);
      // The /cart page is server-rendered (line prices, subtotal, empty state),
      // so re-render it by reloading once the change has been committed.
      if (document.body.classList.contains('template-cart')) window.location.reload();
      return cart;
    });
  }

  /* Delegated at the document level so the +/- and Remove controls work in BOTH
     the cart drawer (JS-rendered) and on the /cart page (Liquid-rendered). */
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return;
    var btn = target.closest('[data-qty-change]');
    if (!btn) return;
    e.preventDefault();
    var qty = parseInt(btn.getAttribute('data-qty'), 10);
    if (isNaN(qty) || qty < 0) return;
    if (btn.getAttribute('aria-disabled') === 'true') return;
    btn.setAttribute('aria-disabled', 'true');
    changeLine(
      btn.getAttribute('data-qty-change'),
      qty,
      btn.hasAttribute('data-qty-line')
    ).catch(function () {}).then(function () { btn.removeAttribute('aria-disabled'); });
  });

  /* Typed quantities on the /cart page (the input has a name, so it also
     submits with the Update button when JS is unavailable). */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || typeof input.closest !== 'function') return;
    if (!input.matches('[data-qty-input]')) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) { input.value = input.defaultValue; return; }
    changeLine(input.getAttribute('data-qty-input'), qty).catch(function () {});
  });

  /* Persist the cart note as soon as the buyer leaves the field. Delegated so it
     covers the drawer's note AND the /cart page note — on /cart a +/- click
     reloads the page, which used to throw away a note the buyer had just typed
     but not yet submitted with the Update button. */
  document.addEventListener('change', function (e) {
    var field = e.target;
    if (!field || typeof field.matches !== 'function') return;
    if (!field.matches('[data-cart-note]')) return;
    fetch(routes.cart_update_url ? routes.cart_update_url + '.js' : '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ note: field.value })
    }).catch(function () {});
  });

  /* Rider profile ("What do you ride?") — saved as a cart attribute so it
     reaches the order and the email tools. Modelled on the note handler. */
  document.addEventListener('change', function (e) {
    var select = e.target;
    if (!select || typeof select.matches !== 'function') return;
    if (!select.matches('[data-cart-ride]')) return;
    fetch(routes.cart_update_url ? routes.cart_update_url + '.js' : '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'What do you ride': select.value } })
    }).catch(function () {});
  });

  /* ---------- Add to cart (product form + quick add) ----------
     aria-disabled does NOT stop a click, and the PDP form has two submit
     buttons (the in-page one and the sticky bar's form="product-form"), so a
     double-tap used to POST /cart/add.js twice and add the line twice. The
     in-flight flag lives on the form, which is what both buttons submit. */
  function handleAddToCart(form) {
    if (form.__ryvoxAdding) return;
    if (form.querySelector('[data-ry-wheel-model]') && !form.reportValidity()) return;
    form.__ryvoxAdding = true;
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.innerHTML = strings.adding || 'Adding…'; }
    var formData = new FormData(form);
    fetch(routes.cart_add_url ? routes.cart_add_url + '.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (btn) { btn.innerHTML = res.data.description || (strings.error || 'Error'); }
          return;
        }
        refreshCart(true).catch(function () {});
        if (btn) btn.innerHTML = strings.added || 'Added ✓';
      })
      .catch(function () { if (btn) btn.innerHTML = strings.error || 'Error'; })
      .finally(function () {
        form.__ryvoxAdding = false;
        setTimeout(function () {
          if (btn) { btn.removeAttribute('aria-disabled'); btn.innerHTML = original; }
        }, 1400);
      });
  }

  $all('form[data-product-form], form[data-quick-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      handleAddToCart(form);
    });
  });

  /* ---------- PDP gallery: scroll-snap carousel (mobile swipe + dots, desktop thumbs) ---------- */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  $all('[data-gallery]').forEach(function (gallery) {
    var track = $('[data-gallery-track]', gallery);
    if (!track) return;
    var slides = $all('[data-gallery-slide]', track);
    var thumbs = $all('[data-gallery-thumb]', gallery);
    var dotsWrap = $('[data-gallery-dots]', gallery);
    var dots = dotsWrap ? $all('button', dotsWrap) : [];
    var activeIndex = 0;

    function setActive(i) {
      activeIndex = i;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
    /* Chrome refuses a programmatic smooth scrollTo() inside a
       scroll-snap-type: x mandatory container (the snap wins and the track
       never moves), so snapping is lifted for the duration of the animation
       and restored once it has settled. Instant scrolls keep snap on. */
    var snapTimer = null;
    function goTo(i, instant) {
      if (i < 0 || i >= slides.length) return;
      var left = slides[i].offsetLeft;
      if (instant || reduceMotion) {
        track.scrollTo({ left: left, behavior: 'auto' });
      } else {
        clearTimeout(snapTimer);
        track.style.scrollSnapType = 'none';
        track.scrollTo({ left: left, behavior: 'smooth' });
        snapTimer = setTimeout(function () {
          track.style.scrollSnapType = '';
          if (Math.abs(track.scrollLeft - left) > 2) track.scrollTo({ left: left, behavior: 'auto' });
        }, 650);
      }
      setActive(i);
    }

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        setActive(Math.min(Math.max(i, 0), slides.length - 1));
      });
    }, { passive: true });

    // Public API used by the variant engine to sync media with the selection.
    // Published on BOTH the [data-gallery] section and the [data-gallery-main]
    // element inside it: the variant engine looks it up via [data-gallery-main]
    // (main-product.liquid puts the two attributes on different elements), so
    // publishing it only on the section left variant images never switching.
    var galleryApi = {
      goToIndex: function (i, instant) { goTo(i, instant); },
      goToMedia: function (mediaId, img, instant) {
        var target = -1;
        slides.forEach(function (s, n) {
          if (s.getAttribute('data-media-id') === String(mediaId)) target = n;
        });
        if (target >= 0) {
          if (target !== activeIndex) goTo(target, instant);
          return;
        }
        // Fallback: variant image not in the gallery — swap the first slide,
        // including srcset and alt (not just src).
        if (img && slides[0]) {
          var el = slides[0].querySelector('img');
          if (el) {
            el.src = img.src;
            if (img.srcset) el.setAttribute('srcset', img.srcset);
            if (img.alt != null) el.alt = img.alt;
          }
          if (activeIndex !== 0) goTo(0, instant);
        }
      }
    };
    gallery.__ryvoxGallery = galleryApi;
    var galleryMain = $('[data-gallery-main]', gallery);
    if (galleryMain) galleryMain.__ryvoxGallery = galleryApi;
  });

  /* ---------- Variant selection: price, stock badge, sticky bar, media, wheel-builder ---------- */
  var BADGE_STATES = {
    in:       { cls: 'stock-badge--in',       label: 'In stock',  micro: '' },
    /* Untracked inventory does not establish stock or a dispatch estimate.
       Show no generic warning; specific order states retain their own copy. */
    orderin:  { cls: null,                    label: null,        micro: '' },
    preorder: { cls: 'stock-badge--preorder', label: 'Reserve', micro: '' },
    oem:      { cls: 'stock-badge--oem',      label: 'OEM order', micro: 'Dealer-order' },
    built:    { cls: 'stock-badge--built',    label: 'Built to order', micro: 'Typically 2–6 weeks' },
    /* Backordered at the supplier (variant JSON bo/bo_s/bo_l/bo_p, from the
       ryvox.backorder metafields). Still buyable; the micro-line carries the
       supplier's restock date when there is one. */
    backorder:{ cls: 'stock-badge--backorder',label: 'Backordered', micro: 'Restock date to be confirmed' },
    /* Booking: a service is neither stocked nor shipped, and RYVOX has
       published no booking lead time, so it states none. */
    service:  { cls: 'stock-badge--service',  label: 'Booking',   micro: '' },
    soldout:  { cls: 'stock-badge--soldout',  label: 'Sold out',  micro: '' }
  };

  $all('[data-variant-selects]').forEach(function (root) {
    var jsonEl = $('[data-variant-json]', root.closest('[data-gallery]') || document);
    var data = null;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (!data || !data.length) return;

    var section = root.closest('[data-gallery]');
    var galleryEl = section ? $('[data-gallery-main]', section) : null;
    var photoNotice = section ? $('[data-option-photo-notice]', section) : null;
    var photoNoticeValue = photoNotice ? $('[data-option-photo-value]', photoNotice) : null;
    var form = $('form[data-product-form]', root) || document.querySelector('form[data-product-form]');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var priceEl = $('[data-pdp-price]', root);
    var addBtn = form ? form.querySelector('[data-add-btn]') : null;
    var actionsEl = form ? form.querySelector('[data-actions]') : null;
    var badgeEl = $('[data-stock-badge]', root);
    var notifyWrap = $('[data-notify-wrap]', root);
    var notifySubject = notifyWrap ? $('[data-notify-subject]', notifyWrap) : null;
    var notifyBody = notifyWrap ? $('[data-notify-body]', notifyWrap) : null;
    var stickyBar = $('[data-sticky-atc]');
    var stickyPrice = stickyBar ? $('[data-sticky-price]', stickyBar) : null;
    var stickyBtn = stickyBar ? $('[data-sticky-btn]', stickyBar) : null;
    var totalEl = $('[data-wb-total]', root);
    var totalAmountEl = totalEl ? $('[data-wb-total-amount]', totalEl) : null;
    var boLines = $all('[data-backorder-line]', root);
    var boProp = form ? form.querySelector('[data-bo-prop]') : null;

    var isOem = root.getAttribute('data-oem') === 'true';
    var oemWrap = $('[data-oem-wrap]', root);
    var oemBody = oemWrap ? $('[data-oem-body]', oemWrap) : null;
    // data-preorder is resolved server-side in main-product.liquid and is true for
    // either tag spelling ("preorder" or "pre-order") — no tag parsing needed here.
    var isPreorder = root.getAttribute('data-preorder') === 'true';
    var preorderLabel = root.getAttribute('data-preorder-label') || 'Reserve';
    // Built-to-order (tag "built-to-order", resolved in main-product.liquid):
    // laced wheels / wheel sets. The build window rides in data-built-eta.
    var isBuilt = root.getAttribute('data-built') === 'true';
    var builtEta = root.getAttribute('data-built-eta') || '2–6 weeks';
    /* Service SKUs (consultations, installs, tunes, shop labour) carry no
       data-* flag of their own. main-product.liquid resolves the Booking state
       server-side and prints it into the badge, and this script is deferred, so
       the rendered badge is already in the DOM and is the signal. Read once,
       here, before the first renderBadge() overwrites it. */
    var isService = !!(badgeEl && badgeEl.querySelector('.stock-badge--service'));
    /* Grouped pill picker: every product with 2+ options gets it (dead-combo
       filtering + price deltas). Single-option products keep a plain pill row
       with nothing disabled, so a sold-out value can still be selected and the
       notify-me form can do its job. */
    var grouped = root.getAttribute('data-grouped') === 'true';
    var productTitle = root.getAttribute('data-product-title') || '';
    var productUrl = root.getAttribute('data-product-url') || '';

    var fieldsets = $all('.variant-fieldset', root);
    var groups = fieldsets.map(function (fs) {
      return $all('input[type="radio"]', fs);
    });

    /* If the checked value is hidden behind a "Show all N" toggle, open that
       group so the buyer can see what is currently selected. Runs on load AND
       after every combo pass — dead-combo filtering can hop the selection onto
       a collapsed value (common on wheel products with 8+ colourways), and a
       checked pill the buyer cannot see reads as "nothing is selected". */
    function revealCheckedIfHidden() {
      fieldsets.forEach(function (fs) {
        if (fs.classList.contains('is-expanded')) return;
        var checked = $('input[type="radio"]:checked', fs);
        if (!checked || !checked.hasAttribute('data-extra')) return;
        fs.classList.add('is-expanded');
        var toggle = $('[data-vgroup-toggle]', fs);
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'true');
          if (!toggle.getAttribute('data-label-more')) toggle.setAttribute('data-label-more', toggle.textContent);
          toggle.textContent = toggle.getAttribute('data-label-less') || 'Show less';
        }
      });
    }
    revealCheckedIfHidden();

    function currentOptions() {
      return groups.map(function (inputs) {
        var checked = inputs.filter(function (i) { return i.checked; })[0];
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      if (!opts.length) return data[0]; // single-variant product: no option pickers rendered
      for (var i = 0; i < data.length; i++) {
        var v = data[i], match = true;
        for (var j = 0; j < opts.length; j++) {
          if (v.options[j] !== opts[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    /* Shared stock-state convention:
       soldout > preorder > oem > built > service > (tracked && qty > 0 => in) > orderin
       Same order as the badge cascade in sections/main-product.liquid. */
    function stockState(v) {
      if (!v || !v.available) return 'soldout';
      /* Backorder outranks everything but Sold out, same as the Liquid cascade. */
      if (v.bo) return 'backorder';
      /* 23 Sep 2026: a Reserve (preorder-tagged) product can hold real stock
         in one colour while the other colours are sold from the next shipment.
         Tracked units on hand beat the tag for that variant only; the tag still
         rules every variant at zero. */
      if (isPreorder) return (v.tracked && v.qty > 0) ? 'in' : 'preorder';
      if (isOem) return 'oem';
      if (isBuilt) return 'built';
      if (isService) return 'service';
      if (v.tracked && v.qty > 0) return 'in';
      return 'orderin';
    }

    function renderBadge(state, v) {
      if (!badgeEl) return;
      var b = BADGE_STATES[state];
      var micro = state === 'built' ? 'Typically ' + builtEta
        : state === 'backorder' ? (v && v.bo_s ? 'Ships after ' + escapeHtml(v.bo_s) : b.micro)
        : b.micro;
      /* A state may legitimately have no badge (orderin). The pill used to be
         written unconditionally, which on a null cls/label would print an empty
         one — a stray blank chip next to the price. Badge and micro-line are
         built independently now; with no badge the micro-line takes the --solo
         modifier and stands where the pill was, which is exactly what
         sections/main-product.liquid renders for that branch server-side. */
      var hasBadge = !!(b.cls && b.label);
      badgeEl.innerHTML =
        (hasBadge ? '<span class="badge stock-badge ' + b.cls + '">' + b.label + '</span>' : '') +
        (micro ? '<span class="stock-badge__micro' + (hasBadge ? '' : ' stock-badge__micro--solo') + '">' + micro + '</span>' : '');
    }

    function setBtn(btn, state) {
      if (!btn) return;
      if (state === 'soldout') {
        btn.setAttribute('disabled', '');
        btn.textContent = strings.sold_out || 'Sold out';
      } else {
        btn.removeAttribute('disabled');
        /* A service keeps the label the server rendered ("Book this service").
           Overwriting it with "Add to cart" is what the one-shot re-apply in
           sections/main-product.liquid was written to undo. */
        if (state === 'service') return;
        btn.textContent = state === 'preorder' ? preorderLabel : (strings.add_to_cart || 'Add to cart');
      }
    }

    /* Dead-combo filtering: a value in group g is selectable only if some
       AVAILABLE variant matches the chosen values of every earlier group plus
       this value. If the checked pill dies, hop to the first live one and re-run. */
    function comboAlive(opts, g, value) {
      for (var i = 0; i < data.length; i++) {
        var v = data[i];
        if (!v.available) continue;
        var ok = v.options[g] === value;
        for (var j = 0; ok && j < g; j++) {
          if (opts[j] !== null && v.options[j] !== opts[j]) ok = false;
        }
        if (ok) return true;
      }
      return false;
    }

    var anyAvailable = data.some(function (v) { return v.available; });
    var DEAD_REASON = 'Not available with the rest of your selection';

    function applyCombos() {
      // Nothing buyable at all (whole product sold out): leave every pill live so
      // the buyer can still pick a value and reach the notify-me form.
      if (!grouped || !anyAvailable) return;
      var passes = 0, changed = true;
      while (changed && passes <= groups.length) {
        changed = false;
        passes++;
        var opts = currentOptions();
        groups.forEach(function (inputs, g) {
          inputs.forEach(function (input) {
            var dead = !comboAlive(opts, g, input.value);
            input.disabled = dead;
            var label = input.nextElementSibling;
            if (label && label.tagName === 'LABEL') {
              if (dead) label.setAttribute('title', DEAD_REASON);
              else label.removeAttribute('title');
            }
          });
          var checked = inputs.filter(function (i) { return i.checked; })[0];
          if (checked && checked.disabled) {
            var firstAlive = inputs.filter(function (i) { return !i.disabled; })[0];
            if (firstAlive) {
              checked.checked = false;
              firstAlive.checked = true;
              changed = true;
            }
          }
        });
      }
      // Explain the greyed-out pills, per group, only where there are any.
      fieldsets.forEach(function (fs, g) {
        var note = $('[data-vgroup-note]', fs);
        if (!note) return;
        note.hidden = !(groups[g] || []).some(function (i) { return i.disabled; });
      });
    }

    /* Price deltas on option pills, relative to the current selection's price. */
    function applyDeltas(current) {
      if (!grouped || !current) return;
      var opts = currentOptions();
      groups.forEach(function (inputs, g) {
        inputs.forEach(function (input) {
          var label = input.nextElementSibling;
          if (!label || label.tagName !== 'LABEL') return;
          var span = label.querySelector('.opt-delta');
          if (!span) {
            span = document.createElement('span');
            span.className = 'opt-delta';
            label.appendChild(span);
          }
          var swapped = opts.slice();
          swapped[g] = input.value;
          var v = findVariant(swapped);
          var text = '';
          if (v && v.id !== current.id) {
            var delta = v.price - current.price;
            if (delta !== 0) text = (delta > 0 ? '+' : '−') + money(Math.abs(delta));
          }
          span.textContent = text;
        });
      });
    }

    function selectedTitle(v) {
      if (v) return v.title;
      return currentOptions().filter(function (o) { return o !== null; }).join(' / ');
    }

    /* Echo the chosen value next to the option name ("Hub colour — GOLD"),
       which is what makes a stacked mobile picker readable at a glance. */
    function renderSelectedLabels() {
      fieldsets.forEach(function (fs, g) {
        var out = $('[data-selected-value]', fs);
        if (!out) return;
        var checked = (groups[g] || []).filter(function (i) { return i.checked; })[0];
        out.textContent = checked ? checked.value : '';
      });
    }

    function update(initial) {
      applyCombos();
      revealCheckedIfHidden();
      renderSelectedLabels();
      var v = findVariant(currentOptions());
      var state = stockState(v);
      var unavailable = state === 'soldout';

      if (v && idInput) idInput.value = v.id;

      if (v && priceEl) {
        priceEl.innerHTML = v.compare_at_price && v.compare_at_price > v.price
          ? '<span class="price__sale">' + money(v.price) + '</span> <span class="price__compare">' + money(v.compare_at_price) + '</span>'
          : '<span>' + money(v.price) + '</span>';
      }

      renderBadge(state, v);
      setBtn(addBtn, state);

      /* Backorder: the full line under the buy button and the order's
         "Backorder" line-item property follow the selected variant. The
         property input is disabled (left out of the post) for every other
         state, so a clean variant never carries a stale note. */
      var onBo = state === 'backorder';
      boLines.forEach(function (el) {
        var kind = el.getAttribute('data-backorder-line');
        var show = onBo && (kind === 'dated' ? !!(v && v.bo_l) : !(v && v.bo_l));
        el.hidden = !show;
        if (show && kind === 'dated') {
          var d = el.querySelector('[data-bo-date]');
          if (d) d.textContent = v.bo_l;
        }
      });
      if (boProp) {
        boProp.disabled = !onBo;
        boProp.value = onBo && v ? (v.bo_p || 'Restock date to be confirmed') : '';
      }

      /* Lines that are only true for one state of a Reserve product: the
         reserve note / ship window while the selected variant is Reserve, the
         ship-by line while it is on the shelf. Elements opt in with
         data-state-line="in" | "preorder"; nothing else on the page is touched. */
      $all('[data-state-line]', root).forEach(function (el) {
        el.hidden = el.getAttribute('data-state-line') !== state;
      });

      // Sticky bar (mobile + condensed desktop): price and button track the selection.
      if (v && stickyPrice) stickyPrice.textContent = money(v.price);
      setBtn(stickyBtn, state);

      // Unavailable variant: swap the dead button for the notify-me form.
      if (notifyWrap) {
        var vtitle = selectedTitle(v);
        notifyWrap.hidden = !unavailable;
        if (actionsEl) actionsEl.hidden = unavailable;
        if (notifySubject) {
          notifySubject.value = 'Restock request: ' + productTitle + (vtitle ? ' — ' + vtitle : '');
        }
        if (notifyBody) {
          notifyBody.value = 'Please email me when this is available again: ' + productTitle +
            (vtitle ? ' (' + vtitle + (v ? ', variant ID ' + v.id : '') + ')' : '') +
            (productUrl ? ' — ' + productUrl : '');
        }
      }

      // OEM inquiry: keep the prefilled hidden body in sync with the selection (title + SKU).
      if (oemBody && v) {
        var oemVt = (v.title && v.title !== 'Default Title') ? ' — ' + v.title : '';
        var oemSku = v.sku ? ' (SKU ' + v.sku + ')' : '';
        oemBody.value = 'OEM part inquiry: ' + productTitle + oemVt + oemSku +
          (productUrl ? ' — ' + productUrl : '');
      }

      // Wheel builder: running total + per-pill deltas.
      if (v && totalAmountEl) totalAmountEl.textContent = money(v.price);
      applyDeltas(v);

      if (photoNotice) {
        photoNotice.hidden = !v || v.media_id != null;
        if (photoNoticeValue) photoNoticeValue.textContent = v ? v.title : '';
      }

      // Variant media: scroll the gallery to the variant's featured image
      // (slide images carry full srcset; fallback swaps src + srcset + alt).
      if (v && v.media_id != null && galleryEl && galleryEl.__ryvoxGallery) {
        galleryEl.__ryvoxGallery.goToMedia(v.media_id, v.img, initial === true);
      } else if (v && galleryEl && galleryEl.__ryvoxGallery && initial !== true) {
        // No render for this variant: fall back to the product's lead image rather
        // than leaving the previous variant's colourway on screen.
        galleryEl.__ryvoxGallery.goToIndex(0, false);
      }

      if (v && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    /* Long option lists render pills AND a native select (mobile.css decides
       which one the viewport shows). The radios stay the single source of
       truth: the select writes into them, and every combo pass writes back so
       the two never disagree. */
    var vselects = $all('[data-vgroup-select]', root);
    function syncSelects() {
      vselects.forEach(function (sel) {
        var fs = sel.closest('.variant-fieldset');
        if (!fs) return;
        var checked = $('input[type="radio"]:checked', fs);
        if (checked && sel.value !== checked.value) sel.value = checked.value;
        var byValue = {};
        $all('input[type="radio"]', fs).forEach(function (i) { byValue[i.value] = i; });
        $all('option', sel).forEach(function (o) {
          var input = byValue[o.value];
          if (!input) return;
          o.disabled = input.disabled;
          var base = o.getAttribute('data-label') || o.textContent.replace(/ — unavailable$/, '');
          o.setAttribute('data-label', base);
          o.textContent = input.disabled ? base + ' — unavailable' : base;
        });
      });
    }
    vselects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var fs = sel.closest('.variant-fieldset');
        var input = fs && $all('input[type="radio"]', fs).filter(function (i) { return i.value === sel.value; })[0];
        if (input && !input.checked) { input.checked = true; update(false); }
      });
    });

    root.addEventListener('change', function (e) {
      if (e.target && (e.target.name === 'quantity' || e.target.closest('.notify-form'))) return;
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-vgroup-select')) return;
      update(false);
      syncSelects();
    });
    update(true);
    syncSelects();
  });

  /* ---------- Sticky mobile ATC ---------- */
  var stickyAtc = $('[data-sticky-atc]');
  var atcAnchor = $('[data-atc-anchor]');
  if (stickyAtc && atcAnchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      stickyAtc.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -60% 0px' }).observe(atcAnchor);
  }

  /* ---------- Predictive search ---------- */
  var searchInput = $('[data-predictive-input]');
  var searchResults = $('[data-predictive-results]');
  if (searchInput && searchResults) {
    var t;
    searchInput.addEventListener('input', function () {
      clearTimeout(t);
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      t = setTimeout(function () {
        var url = (routes.predictive_search_url || '/search/suggest') +
          '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page&resources[limit]=6';
        fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) { renderPredictive(data.resources && data.resources.results); })
          .catch(function () {});
      }, 220);
    });
  }
  function renderPredictive(res) {
    if (!res) { searchResults.innerHTML = ''; return; }
    var html = '';
    if (res.products && res.products.length) {
      html += '<div class="predictive__group"><h4>' + (strings.products || 'Products') + '</h4>';
      html += res.products.map(function (p) {
        var img = (p.featured_image && p.featured_image.url) || (p.image) || '';
        return '<a class="predictive__product" href="' + escapeHtml(p.url) + '">' +
          (img ? '<img src="' + escapeHtml(img) + '" alt="" width="48" height="48" loading="lazy">' : '') +
          '<span>' + escapeHtml(p.title) + '</span></a>';
      }).join('');
      html += '</div>';
    }
    var side = '';
    if (res.collections && res.collections.length) {
      side += '<div class="predictive__group"><h4>' + (strings.collections || 'Collections') + '</h4>' +
        res.collections.map(function (c) { return '<a class="predictive__product" href="' + escapeHtml(c.url) + '"><span>' + escapeHtml(c.title) + '</span></a>'; }).join('') + '</div>';
    }
    if (res.pages && res.pages.length) {
      side += '<div class="predictive__group"><h4>' + (strings.pages || 'Pages') + '</h4>' +
        res.pages.map(function (pg) { return '<a class="predictive__product" href="' + escapeHtml(pg.url) + '"><span>' + escapeHtml(pg.title) + '</span></a>'; }).join('') + '</div>';
    }
    searchResults.innerHTML = (html || '<p class="text-muted">' + (strings.no_results || 'No results') + '</p>') +
      (side ? '<div>' + side + '</div>' : '');
  }

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $all('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $all('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Mobile filter drawer toggle ---------- */
  $all('[data-toggle-facets]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = $('[data-facets-panel]');
      if (target) target.classList.toggle('is-open');
    });
  });

  // Initial cart hydrate (keeps count accurate on load). Caught: a failed
  // /cart.js on load is cosmetic, but an unhandled rejection is not.
  refreshCart(false).catch(function () {});
})();
